import { Constants } from '@babylonjs/core/Engines/constants';
import { type Texture } from '@babylonjs/core/Materials/Textures/texture';
import { type Scene } from '@babylonjs/core/scene';
import { type Logo } from '@seddi/scene';
import { MaterialExt, textureSetSize } from '@seddi/ui-babylon-core';
import { type IBabylonLogo } from './logoTypes';
import { type SurfaceMaterialLoader } from './surfaceMaterialLoader';

/**
 * Loads a logo.
 */
export class LogoLoader {
  private scene: Scene;
  private surfaceMaterialLoader: SurfaceMaterialLoader;

  constructor(scene: Scene, surfaceMaterialLoader: SurfaceMaterialLoader) {
    this.scene = scene;
    this.surfaceMaterialLoader = surfaceMaterialLoader;
  }

  /**
   * Loads a logo.
   * @param data - Logo to load.
   */
  async loadAsync(data: Logo): Promise<IBabylonLogo> {
    const material = await this.surfaceMaterialLoader.loadAsync(data.materials[0]);
    material.transparencyMode = MaterialExt.TRANSPARENCY_MODE_ALPHATESTANDBLEND;

    const albedoTexture = material.albedoTexture as Texture;
    albedoTexture.wrapU = Constants.TEXTURE_CLAMP_ADDRESSMODE;
    albedoTexture.wrapV = Constants.TEXTURE_CLAMP_ADDRESSMODE;
    material.useAlphaFromAlbedoTexture = true;
    textureSetSize(albedoTexture, data.size);

    const logo: IBabylonLogo = { material, size: data.size };

    return logo;
  }

  /**
   * Unloads a logo.
   * @param button - Logo to unload.
   */
  // eslint-disable-next-line @typescript-eslint/require-await -- Keep common interface
  async unload(logo: IBabylonLogo) {
    logo.material.dispose();
  }
}
